import { useLayoutEffect, useRef } from "react";

const OFFSET_TOP_PROPERTY = "--viewport-fill-offset-top";

export const useFillViewportHeight = <T extends HTMLElement>() => {
  const ref = useRef<T>(null);

  useLayoutEffect(() => {
    const node = ref.current;

    if (!node) return;

    const update = () => {
      const offsetTop = Math.ceil(node.getBoundingClientRect().top + window.scrollY);
      const value = `${offsetTop}px`;

      if (node.style.getPropertyValue(OFFSET_TOP_PROPERTY) !== value) {
        node.style.setProperty(OFFSET_TOP_PROPERTY, value);
      }
    };

    update();

    const observer = new ResizeObserver(update);
    observer.observe(document.body);
    window.addEventListener("resize", update);

    return () => {
      observer.disconnect();
      window.removeEventListener("resize", update);
    };
  }, []);

  return ref;
};
